import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationPlacement} from "../types/ReservationPlacement";

// An empty property number or vendor name counts as missing
export const createReservationRequest = (property: IPropertyDetail, placement: ReservationPlacement): IReservationRequest => ({
    propertyId: property.id,
    offerId: property.offer.id,
    vendorId: property.offer.vendor.id,
    propertyNumber: property.number || null,
    vendorName: property.offer.vendor.name || null,
    offerType: property.offer.type,
    placement
});
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationPlacement} from "../types/ReservationPlacement";

// An empty property number or vendor name counts as missing
export const createReservationRequest = (property: IPropertyDetail, placement: ReservationPlacement): IReservationRequest => ({
    propertyId: property.id,
    offerId: property.offer.id,
    vendorId: property.offer.vendor.id,
    propertyNumber: property.number || null,
    vendorName: property.offer.vendor.name || null,
    offerType: property.offer.type,
    placement
});
